import { render, staticRenderFns } from "./ReviewPopup.vue?vue&type=template&id=06bd5814&scoped=true&"
import script from "./ReviewPopup.vue?vue&type=script&lang=js&"
export * from "./ReviewPopup.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPopup.vue?vue&type=style&index=0&id=06bd5814&lang=scss&scoped=true&"
import style1 from "./ReviewPopup.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ReviewPopup.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bd5814",
  null
  
)

export default component.exports